import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Product } from "@/model/entities/product";
import { DialogBaseComponent, DialogParams } from "@/shared/dialog-base.component";
import { DomainService } from "@/shared/domain.service";

export interface SubstitutionConfirmDialogParams extends DialogParams {
  expectedProduct: Product;
  actualProduct: Product;
}

@Component({
  selector: "app-substitution-confirm-dialog",
  templateUrl: "./substitution-confirm-dialog.component.html",
  standalone: false,
})
export class SubstitutionConfirmDialogComponent extends DialogBaseComponent<SubstitutionConfirmDialogParams> {
  constructor(
    config: DynamicDialogConfig<SubstitutionConfirmDialogParams>,
    dialogRef: DynamicDialogRef,
    domainService: DomainService,
  ) {
    super(config, dialogRef, domainService);
    this.isPageReady = true;
  }

  get expectedLabel(): string {
    return this.describeProduct(this.params.expectedProduct);
  }

  get actualLabel(): string {
    return this.describeProduct(this.params.actualProduct);
  }

  private describeProduct(p: Product | undefined): string {
    if (!p) return "(unknown)";
    const mfr = p.productType?.manufacturer?.name ?? "";
    const style = p.productType?.style ?? "";
    const features = p.featureChoicesExtract ?? "";
    return [mfr, style, features].filter((s) => !!s).join(" ");
  }

  onOk() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
